<template>
  <div v-if="state.confirmation.visible" class="confirm-backdrop">
    <div class="confirm-card" role="dialog" aria-modal="true">
      <h5 class="mb-2">{{ state.confirmation.title }}</h5>
      <p class="text-muted mb-4">{{ state.confirmation.message }}</p>
      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-light" type="button" @click="choose(false)">
          {{ state.confirmation.cancelText }}
        </button>
        <button class="btn btn-danger" type="button" @click="choose(true)">
          {{ state.confirmation.confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import state, { resolveConfirmation } from "@/state/app";

export default {
  name: "AppConfirm",
  data() {
    return { state };
  },
  methods: {
    choose: resolveConfirmation,
  },
};
</script>

<style scoped>
.confirm-backdrop {
  position: fixed;
  inset: 0;
  z-index: 10002;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(16, 24, 40, 0.55);
}

.confirm-card {
  width: min(100%, 420px);
  padding: 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(16, 24, 40, 0.25);
}
</style>
